<template>
    <div class="d-flex gap-4 border-b relative cart-items-wrapper">
        <div class="flex-0 product-image-w">
            <div class="rounded-md overflow-hidden ">
                <img
                    :src="product.image ? '/storage/products/' + product.image : '/images/default_image.svg'"
                    :alt="product.title"
                    class="product-image"
                />
            </div>
        </div>
        <div class="d-flex flex-column flex-1 product-details-w" style="margin-right: 1.6rem;">
            <h4 class="text-custom-color-primary-1 font-[600] leading-[1.2] text-sm product-category mb-1">{{ product.category }}</h4>
            <h3 class="font-weight-bold  leading-[1.6] product-title">{{ product.title }}</h3>
            <div class="text-[1.2rem] font-[700] text-[#21343d] product-price">USD{{ product.formatted_price }}</div>
        </div>
        <svg class="product-bin-icon" @click="removeProduct" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
             xmlns:svgjs="http://svgjs.com/svgjs" x="0" y="0" viewBox="0 0 90 90"
        ><g><path d="M22.078 25.877h45.844l-3.484 45.188c-.089 1.15-.505 2.115-.948 2.65-.442.533-.756.672-1.239.672H27.745c-.484 0-.796-.139-1.239-.672-.443-.535-.86-1.5-.948-2.65zm-8.135-6.5c-4.333 0-4.333 6.5 0 6.5h1.614l3.515 45.684c.183 2.338.98 4.539 2.428 6.297 1.452 1.754 3.724 3.029 6.244 3.029H62.25c2.526 0 4.792-1.275 6.245-3.029 1.453-1.758 2.238-3.959 2.422-6.297l3.521-45.684h1.62c4.334 0 4.334-6.5 0-6.5zM37.943 9.029c-4.339 0-4.339 6.5 0 6.5h14.114a3.248 3.248 0 0 0 3.25-3.252 3.246 3.246 0 0 0-3.25-3.248z" fill="#808080" data-original="#000000" class=""></path></g>
        </svg>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name: "CartItem.vue",
    props: {
        product: {
            type: Object,
        },
    },
    methods: {
        removeProduct() {
            this.$emit('removeProduct', this.product);
        },
    },
}
</script>

<style scoped>
.cart-items-wrapper {
    gap: 1rem;
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #eee;
    position: relative;
    flex-direction: column;
}

.cart-item-details {
    width: 200px;
    max-width: 200px;
}

.product-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: rgb(76 79 82 / 1);
    line-height: 1.6;
    margin-bottom: 5px;
}

.product-image-w {
    width: 100%;
}

.product-image {
    border-radius: 0.375rem;
    display: block;
    width: 100%;
}

.product-category {
    font-size: 0.875rem;
    font-weight: 600;
    color: #f77f00;
    line-height: 1.2;
}

.product-price {
    color: #21343d;
    font-size: 1.2rem;
    font-weight: 700;
}

.product-bin-icon {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    position: absolute;
    right: 0;
    bottom: 30px;
}

h3, h4 {
    margin: .05rem 0;
}

.product-image-w {
    width: 100%;
    height: 100%;
}

@media (min-width: 635px) {
    .cart-items-wrapper {
        flex-direction: row;
    }
    .product-image-w {
        width: 91px;
        height: 61px;
    }

    .product-bin-icon {
        bottom: 30px;
    }

    .product-title {
        font-sie: 1.3rem;
    }
}

@media (min-width: 768px) {
    .product-bin-icon {
        top: 0;
    }
}
</style>
